import React from "react";

export const ZoomInIcon = () => {
  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 7.5C15.8284 7.5 16.5 8.17157 16.5 9V13.5H21C21.8284 13.5 22.5 14.1716 22.5 15C22.5 15.8284 21.8284 16.5 21 16.5H16.5V21C16.5 21.8284 15.8284 22.5 15 22.5C14.1716 22.5 13.5 21.8284 13.5 21V16.5H9C8.17157 16.5 7.5 15.8284 7.5 15C7.5 14.1716 8.17157 13.5 9 13.5H13.5V9C13.5 8.17157 14.1716 7.5 15 7.5Z"
        fill="#2D3648"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.5C0 2.01472 2.01472 0 4.5 0H25.5C27.9853 0 30 2.01472 30 4.5V25.5C30 27.9853 27.9853 30 25.5 30H4.5C2.01472 30 0 27.9853 0 25.5V4.5ZM4.5 3C3.67157 3 3 3.67157 3 4.5V25.5C3 26.3284 3.67157 27 4.5 27H25.5C26.3284 27 27 26.3284 27 25.5V4.5C27 3.67157 26.3284 3 25.5 3H4.5Z"
        fill="#2D3648"
      />
    </svg>
  );
};
